// NOTE: this file was auto-generated with `libraries/icons/src/_private/transform.ts`
// Any manual edits will be overwritten via `rush build`

import { SVGProps } from 'react';

const MoonIcon = (props: SVGProps<SVGSVGElement>) => (
	<svg width="1em" height="1em" viewBox="0 0 77 78" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M37.166 77.5c-16.26 0-31.05-10.22-36.8-25.435a1.941 1.941 0 0 1 2.442-2.524 35.387 35.387 0 0 0 11.444 1.9c19.549 0 35.453-15.905 35.453-35.454 0-4.3-.769-8.516-2.285-12.526A1.941 1.941 0 0 1 49.862.937 39.326 39.326 0 0 1 76.5 38.165c0 21.69-17.645 39.335-39.334 39.335Z"
			fill="#fff"
		/>
	</svg>
);
export default MoonIcon;
